import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  usePagination,
  useTable,
  useSortBy,
  useGlobalFilter,
  useAsyncDebounce,
} from 'react-table'
import { jwtDecode } from 'jwt-decode'
import editIcon from '../assets/images/edit.png'
import deleteIcon from '../assets/images/delete.png'
import * as Styles from './style'
import axios from 'axios'
import * as Styles1 from "../Farmers/components/FarmerForm/style";
import Cookies from 'universal-cookie'
import { act } from 'react'
import Header from 'antd/lib/calendar/Header'
import { changeDateTimeFormat } from '../shared/Helper'
import { UnitTypeSelectionModal } from './UnitTypeSelectionModal'
import { Link } from 'react-router-dom'
import LoadingOverlay from 'react-loading-overlay'
import BounceLoader from 'react-spinners/BounceLoader'
import { toast } from 'react-toastify'
import { Button } from 'react-bootstrap'
import { AddGatewayForm } from './AddGatewayForm'
import { AddHiveCameraForm } from './AddHiveCameraForm'
import { AddSensorTypeForm } from './AddSensorTypeForm'
const cookies = new Cookies()

 

export const AllSensorsTable = () => {
  const { token } = '' //useSelector((state) => state.auth || {});
  const currentToken = cookies.get('access_token')

  const [openModal, setOpenModal] = useState(false)
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showeditModal, setshoweditModal] = useState(-1)
  const [selectedValue, setselectedValue] = useState(-1)
  const USERS_TABLE_COLUMNS = [
    // {
    //   Header: 'DP',
    //   maxWidth: 60,
    //   minWidth: 60,
    //   width: 60,
    //   Cell: ({ row }) => {
    //     return row?.original?.userInfo?.profilePictureUrl ? (
    //       <img
    //         src={row?.original?.userInfo?.profilePictureUrl}
    //         alt="Profile"
    //         style={{ width: '50px', height: '50px', borderRadius: '50%' }}
    //       />
    //     ) : (
    //       <img
    //         src="https://media.istockphoto.com/id/1414774612/vector/bee-character.jpg?s=612x612&w=0&k=20&c=YBLQKadPoBfsSGGLBvkAt_3LqEytdHH3DVEE7dJUxqw="
    //         alt="Profile"
    //         style={{ width: '50px', height: '50px', borderRadius: '50%' }}
    //       />
    //     )
    //   },
    // },
  
    {
      Header: 'Id',
      maxWidth: 80,
      minWidth: 80,
      width: 80,
      Cell: ({ row }) => {
        const Id = (row?.original?.type == 'Gateway' ? row?.original?.gateway_id : row?.original?.hive_camera_id) || "--"
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <p>{Id}</p>
          </div>
        );
      }
    },
    {
      Header: 'Unit Type',
      maxWidth: 80,
      minWidth: 80,
      width: 80,
  
      Cell: ({ row }) => {
        const type = row?.original?.type || "-"
        // if (type == 'Gateway')
        //   return (
        //     <Link to={`sensor/${row?.original.gateway_id}`} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        //       <p>Gateway</p>
        //     </Link>
        //   );
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <p>{type}</p>
          </div>
        );
      }
    },
    {
      Header: 'Last Scene',
      maxWidth: 80,
      minWidth: 80,
      width: 80,
      Cell: ({ row }) => {
        const lastSeen =changeDateTimeFormat(row?.original?.last_seen); // Assuming lastSeen is a valid timestamp
      
        return (
         <p> {lastSeen}</p>
        );
      }
    },
    {
      Header: 'Active',
      maxWidth: 80,
      minWidth: 80,
      width: 80,
      Cell: ({ row }) => {
        const lastSeen = row?.original?.last_seen; // Assuming lastSeen is a valid timestamp
        // Get the time difference in hours
        const lastSeenDate = lastSeen ? new Date(lastSeen) : null;
        const currentTime = new Date();
        const hoursDifference = lastSeenDate
          ? (currentTime - lastSeenDate) / (1000 * 60 * 60)
          : Infinity; // Default to infinite if no lastSeen
        // Determine dot color
        const dotColor = hoursDifference > 4 ? 'red' : 'green';
  
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span
              style={{
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: dotColor,
                display: 'inline-block',
              }}
            ></span>
          </div>
        );
      }
  
    },
    // {
    //   Header: 'Details',
    //   maxWidth: 80,
    //   minWidth: 80,
    //   width: 80,
    //   Cell: ({ row }) => {
    //     const lastSeen = row?.original?.last_seen; // Assuming lastSeen is a valid timestamp
    //     // Get the time difference in hours
    //     const lastSeenDate = lastSeen ? new Date(lastSeen) : null;
    //     const currentTime = new Date();
    //     const hoursDifference = lastSeenDate
    //       ? (currentTime - lastSeenDate) / (1000 * 60 * 60)
    //       : Infinity; // Default to infinite if no lastSeen
    //     // Determine dot color
    //     const dotColor = hoursDifference > 4 ? 'red' : 'green';
  
    //     return (
    //       <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    //         <span
    //           style={{
    //             width: '10px',
    //             height: '10px',
    //             borderRadius: '50%',
    //             backgroundColor: dotColor,
    //             display: 'inline-block',
    //           }}
    //         ></span>
    //       </div>
    //     );
    //   }
  
    // },
    {
      Header: 'Edit',
      maxWidth: 80,
      minWidth: 80,
      width: 80,
      Cell: ({ row }) => {
       
        return (
          <div className="d-flex gap-2">
        <Button variant="primary" size="sm" onClick={() => handleShowModal("edit", row)}>
          Edit
        </Button>
        {/* <Button style={{marginLeft:15}} variant="danger" size="sm" onClick={() => handleDeleteEntity(row._id)}>
        Delete
      </Button> */}
      </div>
        );
      }
  
    },
    // {
    //   Header: "Actions",
    // },
  ]
  const columns = useMemo(() => USERS_TABLE_COLUMNS, [])


  const handleShowModal =(type, SensorData)=>{
    console.log(type,SensorData.original);
    if(SensorData.original.type=='Gateway'){
      console.log('gateway');
      setshoweditModal(0)
      setselectedValue(SensorData.original)
    }
    if(SensorData.original.type=='InHive Sensor'){
      setshoweditModal(2)
      setselectedValue(SensorData.original)
    }
    if(SensorData.original.type=='Hive Camera'){
      setshoweditModal(1)
      setselectedValue(SensorData.original)
    }
  }

  const fetchData = async () => {
    try {
      if(openModal)
      {return ; 
        
      }
      setLoading(true);
      const currentToken = cookies.get('access_token')

      const  headers= {
        headers:{
          authorization: `Bearer ${currentToken}`,
        }
      }
      const responses = await Promise.allSettled([
        axios.get(`${process.env.REACT_APP_HUMBLEBEE_API_URL}/sensors/gateways`,headers),
        axios.get(`${process.env.REACT_APP_HUMBLEBEE_API_URL}/sensors/inhive-sensors`,headers),
        axios.get(`${process.env.REACT_APP_HUMBLEBEE_API_URL}/sensors/hive-cameras`,headers)
      ]);
      
      const extractData = (response, key, type) => {
        if (response.status === 'fulfilled' && Array.isArray(response.value.data)) {
          return response.value.data.map(item => ({ ...item, type }));
        } else {
          console.error(`Error fetching ${key}:`, response.reason);
          return [];
        }
      };
      
      // Extract data safely
      const combinedData = [
        ...extractData(responses[0], 'Gateways', 'Gateway'),
        ...extractData(responses[1], 'InHive Sensors', 'InHive Sensor'),
        ...extractData(responses[2], 'Hive Cameras', 'Hive Camera')
      ];
      
      // Show an error toast only if all requests fail
      if (combinedData.every(arr => arr.length === 0)) {
        toast.error('No data available from any source.');
      }
      
      setData(combinedData);
      setError(null);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 3600000);

    return () => clearInterval(interval);
  }, [openModal]);

  const tableInstance = useTable(
    {
      columns: columns,
      data: data,
    },
    useSortBy,
    usePagination
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    pageCount,
    gotoPage,
    state,
  } = tableInstance
  const { pageIndex } = state

  const handleModalToggle = () => {
    setOpenModal(prev => !prev)
  }

  const handleOpenEditModal = (_id, user) => {
    return
  }

  // if (loading) return <div>Loading...</div>;
  // if (error) return <div>Error fetching data: {error.message}</div>;

  // return (
  //   <> 
  //   <div className="page-container leads-page sidebar-minimized">
  //   <LoadingOverlay
  //     active={loading || false}
  //     spinner={<BounceLoader />}
  //   >
  //     <Styles.UserBox2>
  //     <h3 style={{
  //       fontSize:35,
  //       fontWeight:'600',
  //       color:'#ff8701'
  //     }}>Sensor Table</h3>
  //       <Styles.TableContainer>
  //         <Styles.SearchContainer>

  //           <Styles.ModalButton
  //             onClick={handleModalToggle}
  //             style={{ marginLeft: 'auto', display: 'block' }}
  //           >
  //             Add Unit
  //           </Styles.ModalButton>

  //           {openModal ? (
  //             <UnitTypeSelectionModal openModal={openModal} setOpenModal={setOpenModal} />
  //           ) : null}
  //         </Styles.SearchContainer>
  //         {data ? (
  //           <Styles.Table {...getTableProps()}>
  //             <Styles.THead>
  //               {headerGroups.map(headerGroup => (
  //                 <Styles.THeadRow {...headerGroup.getHeaderGroupProps()}>
  //                   {headerGroup.headers.map(headerColumn => (
  //                     <Styles.TH
  //                       {...headerColumn.getHeaderProps({
  //                         style: {
  //                           minWidth: headerColumn.minWidth,
  //                           width: headerColumn.width,
  //                         },
  //                         // headerColumn.getSortByToggleProps()
  //                       })}
  //                     >
  //                       {headerColumn.render('Header')}
  //                       {/* <span>
  //                       {headerColumn.isSorted
  //                         ? headerColumn.isSortedDesc
  //                           ? ' 🔼'
  //                           : ' 🔽'
  //                         : ''}
  //                     </span> */}
  //                     </Styles.TH>
  //                   ))}
  //                 </Styles.THeadRow>
  //               ))}
  //             </Styles.THead>

  //             <Styles.TBody {...getTableBodyProps()}>
  //               {page.map(singleRow => {
  //                 prepareRow(singleRow)

  //                 return (
  //                   <Styles.TBodyRow {...singleRow.getRowProps()}>
  //                     {singleRow.cells.map((singleCell, index) => (
  //                       <Styles.TD key={index}>
  //                         <span>
  //                           {/* {singleCell.column.id === 'userInfo.addedAt' ||
  //                         singleCell.column.id === 'userInfo.updatedAt' ? (
  //                           <span>
  //                             {singleCell?.value?.length > 0
  //                               ? changeDateTimeFormat(singleCell?.value)
  //                               : '-'}
  //                           </span>
  //                         ) : (
  //                           <>
  //                             <span>                   
  //                                 <span>{singleCell.render('Cell')}</span>
  //                             </span>
  //                             <span>
  //                               {singleCell.column.Header === 'Actions' ? (
  //                                 <Styles.ActionSpan>
  //                                   <button
  //                                     onClick={() =>
  //                                       handleOpenEditModal(
  //                                         singleCell?.row?.original?._id,
  //                                         singleRow?.original
  //                                       )
  //                                     }
  //                                   >
  //                                     <img src={editIcon} alt="Edit" />{' '}
  //                                   </button>
  //                                 </Styles.ActionSpan>
  //                               ) : null}  
  //                             </span>
  //                           </>
  //                         )}
  //                           */}
  //                           {singleCell.render('Cell')}
  //                         </span>
  //                       </Styles.TD>
  //                     ))}
  //                   </Styles.TBodyRow>
  //                 )
  //               })}
  //             </Styles.TBody>
  //           </Styles.Table>
  //         ) : (
  //           <h3>There was some error displaying table</h3>
  //         )}
  //       </Styles.TableContainer>

  //       <Styles.PaginationmainContainer>
  //         <span>
  //           <strong>
  //             Page {pageIndex + 1} of {pageOptions.length}
  //             <br />
  //           </strong>
  //         </span>
  //         <Styles.PaginationDiv>
  //           <Styles.PaginationButton
  //             onClick={() => gotoPage(0)}
  //             disabled={!canPreviousPage}
  //           >
  //             {'<<'}
  //           </Styles.PaginationButton>
  //           <Styles.PaginationButton
  //             onClick={previousPage}
  //             disabled={!canPreviousPage}
  //           >
  //             Previous
  //           </Styles.PaginationButton>

  //           <Styles.PaginationInputDiv>
  //             <input
  //               type="number"
  //               defaultValue={pageIndex + 1}
  //               onChange={e => {
  //                 let jumpToPageNumber = e.target.value
  //                   ? Number(e.target.value) - 1
  //                   : 0
  //                 gotoPage(jumpToPageNumber)
  //               }}
  //             />
  //           </Styles.PaginationInputDiv>

  //           <Styles.PaginationButton onClick={nextPage} disabled={!canNextPage}>
  //             Next
  //           </Styles.PaginationButton>
  //           <Styles.PaginationButton
  //             onClick={() => gotoPage(pageCount - 1)}
  //             disabled={!canNextPage}
  //           >
  //             {'>>'}
  //           </Styles.PaginationButton>
  //         </Styles.PaginationDiv>
  //       </Styles.PaginationmainContainer>
  //     </Styles.UserBox2>
  //   </LoadingOverlay>
  //   </div>
  //   {selectedValue && showeditModal!==-1?
  //   <Styles1.ModalWrapper> 
  //   {showeditModal==0?
  //     <AddGatewayForm type='edit' intialData={selectedValue} handleClose={e=>{setshoweditModal(-1)
  //       setselectedValue(-1)
  //     }} />
  //   :
  //   showeditModal==1?
  //   <AddHiveCameraForm type='edit' intialData={selectedValue} handleClose={e=>{setshoweditModal(-1)
  //     setselectedValue(-1)
  //   }} />
  //   :
  //   showeditModal==2?
  //   <AddSensorTypeForm type='edit' intialData={selectedValue} handleClose={e=>{setshoweditModal(-1)
  //     setselectedValue(-1)
  //   }} />
  //   :null}
  //   </Styles1.ModalWrapper>
  //   :null
  
  // }
  //   </>
  // )

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <h1 style={{ fontSize: 32, color: '#ff8701', margin: 0 }}>Work in progress </h1>
    </div>
  )
}

